// extracted by mini-css-extract-plugin
export var card = "articleCard-module--card--8ae5e";